export const Main = 'main'
